import { FC } from "react";
import { AppPartType } from "../../../types";
import { Input } from "antd";
import moment from "moment";

type Prop = {
  appPart: AppPartType;
};
const Time: FC<Prop> = ({ appPart: { default_value, calc_type } }) => {
  return (
    <Input
      disabled
      value={
        calc_type === "time"
          ? moment(new Date()).format("HH:mm")
          : default_value
      }
    />
  );
};

export default Time;
